import React from 'react';
import PrintPageLayout,{SignatureStamp,SignatureInput} from '../components/PrintPageLayout';
import {Box,Select,Date,Area,Button} from '../components/Input';
import {LoadGraphic} from '../components/Common';
import store from 'store';
import moment from 'moment';
import u from '../utilities/Utilities';
import "../styles/print-page-layout.scss";
import '../styles/incident-closure.scss';

export default class IncidentClosure extends React.Component{

    id = this.props.match.params.id;

    r={};

    state={
        content:{},
        entryData:{},
        options:{},
        loading:false,
        loadText:"",
        permissions:{},
        changesMade:false,
        approvingOptions:[],
    }

    getStaffOptions=()=>{
        u.post({
            url:"/api/get-staff-options",
            data:{
                permission:{
                    incident:{delete:2}
                }
            },
            success:(staffOptions)=>{
                this.setState({approvingOptions:staffOptions.map((item)=>{return {value:item.label,label:item.label}})});
            },
            error:(error)=>{
                this.setState({error:error})
            }
        })
    }

    componentDidMount=()=>{
        this.getStaffOptions();
        const content=store.get(this.id);
        //this.getOptions();
        if(content){
            this.setState({
                content:content,
                entryData:this.onSetup(content),
                permissions:u.getPermissions("incident"),
            });
        }
        else{
            window.location="/404";
        }
    }

    onSetup=(content)=>{
        const entryData=content.closureReport;
        entryData.preparedOn = (entryData.ioSign?.signOn) ? entryData.ioSign.signOn : ((typeof entryData.preparedOn == "undefined") ? moment().format("YYYY-MM-DD HH:mm:ss") : entryData.preparedOn);
        entryData.preparedBy = (entryData.ioSign?.signBy) ? entryData.ioSign.signBy : ((typeof entryData.preparedBy == "undefined") ?  u.getFullName() : entryData.preparedBy);

        entryData.accused = content.involved.filter((item)=>{return item.involvementType == "Accused"}).sort((a,b)=>{return a.name - b.name});
        entryData.victim = content.involved.filter((item)=>{return item.involvementType == "Victim"}).sort((a,b)=>{return a.name - b.name});
        entryData.informant = content.involved.filter((item)=>{return item.involvementType == "Informant" || item.involvementType=="Witness"}).sort((a,b)=>{return a.name - b.name});

        //console.log(entryData);
        return entryData;
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:[],
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                console.log(error);
            }
        });
    }

    onValidate=()=>{
        let keys=[];
    }

    onClickSign=(field,name)=>{
        this.r['layout'].setPopupComponent(
            <SignatureInput onCancel={()=>{this.r['layout'].showPopup(false)}}
                            onComplete={(signatureStamp)=>{
                                this.onChange(signatureStamp,field);
                                this.r['layout'].showPopup(false);
                            }}
                            staffOptions={(field=="aoSign") ? this.state.approvingOptions : undefined}
                            content={{name:name}}
                            />
        );
        this.r['layout'].showPopup(true);
    }

    onChange=(value,field,index)=>{
        let entryData=this.state.entryData;
        if(entryData[field] != value){
            this.setState({changesMade:true})
        }

        entryData[field]=value;
        this.setState({entryData:entryData});

        if(field == "aoSign"){
            this.onSave(entryData);
        }
    }

    onUnsign=()=>{
        const onConfirm=async ()=>{
            this.setState({loading:true,loadText:"Updating..."});
            this.r['layout'].showPopup(false);

            try{
                const {content,entryData}=this.state;
                await u.postAsync({
                    url:"/api/incident-delete-closure-signatures",
                    data:{
                        incidentID:content.incidentID,
                    }
                });
                delete entryData.ioSign;
                delete entryData.aoSign;
                this.setState({loading:false,entryData:entryData});
            }
            catch(e){
                const {error,status} = u.processError(e);
                //console.log(error);
                this.setState({loading:false,error:error});
            }
        }

        this.r['layout'].setPopupComponent(
            <div className='default-popup'>
                <h2 className='text-negative'>Edit Signed Document?</h2>
                <div>
                    Note. All signatures will be deleted once you click confirm and the document will need to be signed again
                </div>
                <div style={{margin:"20px auto"}}>
                    <Button onClick={()=>{this.r['layout'].showPopup(false)}}>Cancel</Button>
                    <Button onClick={onConfirm}>Confirm</Button>
                </div>
            </div>
        );
        this.r['layout'].showPopup(true);
    }

    onSave=(entryData)=>{
        const {content} = this.state;
        if(typeof entryData == "undefined"){
            entryData=this.state.entryData;
        }
        this.setState({loading:true,loadText:"Saving..."});
        u.post({
            url:"/api/incident-save-closure-report",
            data:{
                incidentID:content.incidentID,
                closureReport:entryData,
            },
            success:()=>{
                content.closureReport = entryData;
                store.set(this.id,content);
                this.setState({changesMade:false,loading:false});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    render=()=>{
        const {content,options,entryData,changesMade,permissions}=this.state;
        const hasPerm = (permissions.update == 2);
        const hasSign = (entryData.aoSign?.sign);
        const canEdit = (!hasSign && hasPerm);

        return (
            <PrintPageLayout ref={(ref)=>{this.r['layout']=ref}}
                             title={"Closure Report"}>

                <div className="print-page-container">
                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                    <img className="print-page-header-image" src="/images/app/app-logo.png"/>
                    <div className="print-page-title">Incident Closure Report</div>

                    <div className={'print-table-container' + ((!canEdit) ? " align-top": "")}>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='t-label large'>Dormitory:</td>
                                    <td className='t-input'>{content.dormName}</td>
                                    <td className='t-divider small'/>
                                    <td className='t-label large'>Case No:</td>
                                    <td className='t-input'>{content.caseNumber}</td>
                                </tr>

                                <tr>
                                    <td>Nature of Incident:</td>
                                    <td>{content.natureOfIncident}</td>
                                    <td className='t-divider'/>
                                    <td>Prepared On:</td>
                                    <td>{moment(entryData.preparedOn).format("DD MMM YYYY - h:mma")}</td>
                                </tr>

                                <tr>
                                    <td>Investigating Officer:</td>
                                    <td>{entryData.preparedBy}</td>
                                    <td className='t-divider'/>
                                    <td>IO Contact No:</td>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Box ref={(ref)=>{this.r["ioContactNo"]=ref}}
                                                 label="Gender"
                                                 field="ioContactNo"
                                                 values={{
                                                    value:entryData.ioContactNo,
                                                    enabled:canEdit
                                                 }}
                                                 rules={{
                                                    required:true,
                                                 }}
                                                 onChange={this.onChange}
                                                 />
                                            :
                                            entryData.ioContactNo
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='print-table-container resident-info-table'>
                        <div className='print-table-title'>Accused:</div>
                        {
                            (entryData.accused?.length > 0)
                                ?
                                <table className='small-table-font'>
                                    <tbody>
                                    {
                                        entryData.accused.map(
                                            (item,index)=>{
                                                return (
                                                    <tr key={index}>
                                                        <td className='index'>{index+1}.</td>
                                                        <td>{item.name}</td>
                                                        <td className='fin'>{item.nric}</td>
                                                        <td className='type'>{item.residencyType}</td>
                                                        <td className='contact'>{item.contactNo}</td>
                                                        <td>{item.address}</td>
                                                    </tr>
                                                )
                                            }
                                        )
                                    }
                                    </tbody>
                                </table>
                                :
                                <div className='list-placeholder'>
                                    <b>No Accused</b>
                                </div>
                        }
                    </div>

                    <div className='print-table-container resident-info-table'>
                        <div className='print-table-title'>Victim:</div>
                        {
                            (entryData.victim?.length > 0)
                                ?
                                <table className='small-table-font'>
                                    <tbody>
                                    {
                                        entryData.victim.map(
                                            (item,index)=>{
                                                return (
                                                    <tr key={index}>
                                                        <td className='index'>{index+1}.</td>
                                                        <td>{item.name}</td>
                                                        <td className='fin'>{item.nric}</td>
                                                        <td className='type'>{item.residencyType}</td>
                                                        <td className='contact'>{item.contactNo}</td>
                                                        <td>{item.address}</td>
                                                    </tr>
                                                )
                                            }
                                        )
                                    }
                                    </tbody>
                                </table>
                                :
                                <div className='list-placeholder'>
                                    <b>No Victim</b>
                                </div>
                        }
                    </div>

                    <div className='print-table-container resident-info-table'>
                        <div className='print-table-title'>Informant/Witness:</div>
                        {
                            (entryData.informant?.length > 0)
                                ?
                                <table className='small-table-font'>
                                    <tbody>
                                    {
                                        entryData.informant.map(
                                            (item,index)=>{
                                                return (
                                                    <tr key={index}>
                                                        <td className='index'>{index+1}.</td>
                                                        <td>{item.name}</td>
                                                        <td className='fin'>{item.nric}</td>
                                                        <td className='type'>{item.residencyType}</td>
                                                        <td className='contact'>{item.contactNo}</td>
                                                        <td>{item.address}</td>
                                                    </tr>
                                                )
                                            }
                                        )
                                    }
                                    </tbody>
                                </table>
                                :
                                <div className='list-placeholder'>
                                    No informant/witness added
                                </div>
                        }
                    </div>

                    <div className={'print-table-oneline-container resident-info-table'}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Allegation:</td>
                                </tr>
                                <tr>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Area ref={(ref)=>{this.r["allegation"]=ref}}
                                                  label="Allegation"
                                                  field="allegation"
                                                  values={{
                                                    value:entryData.allegation,
                                                    enabled:canEdit
                                                  }}
                                                  rules={{
                                                    required:true,
                                                    rows:15,
                                                  }}
                                                  onChange={this.onChange}
                                                  />
                                            :
                                            <div className="paragraphed-text">{entryData.allegation}</div>
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={'print-table-oneline-container resident-info-table'}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Investigation:</td>
                                </tr>
                                <tr>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Area ref={(ref)=>{this.r["investigation"]=ref}}
                                                  label="Investigation"
                                                  field="investigation"
                                                  values={{
                                                    value:entryData.investigation,
                                                    enabled:canEdit
                                                  }}
                                                  rules={{
                                                    required:true,
                                                    rows:15,
                                                  }}
                                                  onChange={this.onChange}
                                                  />
                                            :
                                            <div className="paragraphed-text">{entryData.investigation}</div>
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='print-table-oneline-container resident-info-table'>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Conclusion:</td>
                                </tr>
                                <tr>
                                    <td>
                                    {
                                        (canEdit)
                                            ?
                                            <Area ref={(ref)=>{this.r["conclusion"]=ref}}
                                                  label="Conclusion"
                                                  field="conclusion"
                                                  values={{
                                                    value:entryData.conclusion,
                                                    enabled:canEdit
                                                  }}
                                                  rules={{
                                                    required:true,
                                                    rows:15,
                                                  }}
                                                  onChange={this.onChange}
                                                  />
                                            :
                                            <div className="paragraphed-text">{entryData.conclusion}</div>
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='print-table-container'>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='t-label large'>Investigating Officer:</td>
                                    <td className='t-input'>
                                        <SignatureStamp content={entryData.ioSign}
                                                        onClick={()=>{this.onClickSign("ioSign",u.getFullName())}}
                                                        enabled={hasPerm}
                                                        />
                                    </td>
                                    <td className='t-divider small'/>
                                    <td className='t-label large'>Approving Officer:</td>
                                    <td className='t-input'>
                                        <SignatureStamp content={entryData.aoSign}
                                                        onClick={()=>{this.onClickSign("aoSign","")}}
                                                        enabled={hasPerm}
                                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='print-page-hidden no-print'>
                        <div>Note. Report will no longer be editable once the approving officer signs the document</div>
                        <div className='page-error'>{this.state.error}</div>
                        <div>
                            {
                                (hasSign && hasPerm)
                                    ?
                                    <Button onClick={this.onUnsign}>Edit Document</Button>
                                    :
                                    null
                            }
                            <Button enabled={(changesMade && hasPerm)} onClick={this.onSave}>Save Changes</Button>
                        </div>
                    </div>

                </div>
            </PrintPageLayout>
        )
    }
}